import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { Theme } from '@mui/material/styles';

interface Props {
  label: string;
  icon?: ReactNode;
  color?: string;
  bg?: string | ((theme: Theme) => string);
  tooltip?: string;
}

/**
 * Small rounded capability pill: icon + bold label on a tinted background. Shared by the
 * workflow capability badges (MCP / AI) and the workflow detail trigger chips so both use
 * the same layout.
 */
export default function CapabilityPill({
  label,
  icon,
  color = 'text.secondary',
  bg = 'action.hover',
  tooltip,
}: Props) {
  const pill = (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.4,
        borderRadius: '6px',
        bgcolor: bg,
      }}
    >
      {icon}
      <Typography sx={{ fontSize: '0.7rem', fontWeight: 700, color, lineHeight: 1, whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
    </Box>
  );
  return tooltip ? <Tooltip title={tooltip}>{pill}</Tooltip> : pill;
}
